import React from "react";
import { createRoot } from "react-dom/client";
import store from "./redux/store";
import { Provider } from "react-redux";
import App from "./App";
import "./assets/scss/style.scss";
import "react-lazy-load-image-component/src/effects/blur.css";
import "./translations/i18n";
import * as serviceWorker from "./serviceWorker";
import { colors } from "./utils/theme";
import nlNL from "antd/lib/locale/nl_NL";
import { ConfigProvider } from "antd";
import { AuthContextProvider } from "./context/AuthContext";
import { OverlayProvider } from "./context/OverlayContext";

const root = createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <AuthContextProvider>
      <ConfigProvider
        theme={{
          token: {
            colorPrimary: colors.primary,
            fontFamily: "",
          },
          components: {
            Button: {
              colorPrimary: colors.primary,
              colorBorder: colors.primary,
              colorTextLightSolid: "#fff",
              colorText: colors.primary,
              borderColorDisabled: "#d9d9d9",
              primaryShadow: "none",
            },
          },
        }}
        locale={nlNL}
      >
        <OverlayProvider>
          <App />
        </OverlayProvider>
      </ConfigProvider>
    </AuthContextProvider>
  </Provider>,
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
